import React, { type ReactNode } from "react";
import styles from "./PageLayout.module.scss";

interface PageLayoutProps {
  title?: string;
  headerAction?: ReactNode;
  preCardContent?: ReactNode;
  innerTitle?: string;
  innerActions?: ReactNode;
  children: ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  title,
  headerAction,
  preCardContent,
  innerTitle,
  innerActions,
  children,
}) => {
  return (
    <div className={styles.pageLayoutContainer}>
      {/* ── Outer Header ── */}
      {(title || headerAction) && (
        <div className={styles.outerHeader}>
          {title && <h1 className={styles.pageTitle}>{title}</h1>}
          {headerAction && <div className={styles.headerAction}>{headerAction}</div>}
        </div>
      )}

      {/* ── Pre-Card Content (e.g., Stats, Cards) ── */}
      {preCardContent && (
        <div className={styles.preCardContent}>
          {preCardContent}
        </div>
      )}

      {/* ── Inner Card / Box ── */}
      <div className={styles.contentCard}>
        {/* Only render inner header if there's a title or actions */}
        {(innerTitle || innerActions) && (
          <div className={styles.innerHeader}>
            <div className={styles.innerTitleWrapper}>
              {innerTitle && <h2 className={styles.innerTitle}>{innerTitle}</h2>}
            </div>
            {innerActions && <div className={styles.innerActions}>{innerActions}</div>}
          </div>
        )}

        {/* ── Main Content (Table) ── */}
        <div className={styles.mainContent}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageLayout;
